import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/auth";
import { client_selected } from "../client";

const PublicRoute = ({ children }: { children: JSX.Element }) => {
  const location = useLocation();
  const from = location.state?.from;
  const redirectClient = client_selected.redirect;
  const isAuthPath = location.pathname === "autenticacao";

  const { isLoading, isAuthenticated, isTempPassword } = useAuth();

  // SSO Genial em andamento: permite o fluxo processar o token mesmo se
  // já houver um usuário autenticado (para permitir troca de usuário).
  const isGenialSsoFlow =
    location.pathname.includes("/autenticacao/genial") &&
    (window.location.hash.includes("token=") ||
      location.search.includes("token="));

  if (isLoading) {
    return <p>carregando...</p>;
  }

  if (isAuthPath) {
    return (
      <Navigate
        to="/autenticacao/acessar-conta"
        state={{ from: from }}
        replace
      />
    );
  }

  if (
    !!isAuthenticated &&
    !isTempPassword &&
    location.pathname.includes("/autenticacao") &&
    !isGenialSsoFlow
  ) {
    return <Navigate to={redirectClient} state={{ from: from }} replace />;
  }

  return children;
};

export default PublicRoute;
